import { CodeitemLoopComponent } from './../codeitem-loop/codeitem-loop.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CodeItemService } from '../../common/services/codeitem.service';
import { ProgrammingEventService } from '../../common/services/event.service';
import { ProgrammingEvent } from '../services/advanced-programming.service';


@Component({
  selector: 'prg-select-device',
  templateUrl: './select-device.component.html',
  styleUrls: ['./select-device.component.css']
})
export class SelectDeviceComponent implements OnInit {

  devices: Observable<Array<any>>;
  origin: string;
  event: Observable<ProgrammingEvent>;

  constructor(
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private eventService: ProgrammingEventService,
    private codeitemService: CodeItemService
  ) {
    this.event = this.store.select(s => s.advancedProgramming.event.event);

    this.route.parent.params.take(1).subscribe(params => {
      switch (params['origin']) {
        case 'event':
          this.devices = this.store.select(s => s.advancedProgramming.event.devices);
          break;

        case 'codeitem':
          this.devices = this.store.select(s => s.advancedProgramming.codeitem.devices);
          break;

        default:
          console.error('cannot get devices list, invalid route context', params);
          break;
      }
    });
  }

  deviceSelected(value: any) {
    switch (this.origin) {
      case 'event':
        this.eventService.selectDevice(value);
        this.router.navigate([value.id, 'event'], { relativeTo: this.route });
        break;

      case 'codeitem':
        this.codeitemService.selectDevice(value);
        // NOTE a little hackery here, need to programmatically route to one of three next steps: command, condition, or loop
        // these happen to correspond to the route data attached to each relative route, so just use the route data to compose the
        // correct next step
        this.route.params.take(1).subscribe((_params: any) => {
          this.router.navigate([value.id, 'event'], { relativeTo: this.route });
        });
        break;

      default:
        console.error('unable to navigate to post-device selection step, invalid route context', this.origin);
        break;
    }
  }

  ngOnInit() {
    this.route.parent.params.subscribe(params => {
      this.origin = params['origin'];
      console.log('navigated to select-device for ', this.origin);
    });
  }

  searchTextChanged(event) {
    this.eventService.setDeviceSearchText(event.target.value);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/select-device/select-device.component.ts